// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3I8wm","col":"styles_col__1qhdS"};